import * as React from "react";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

export default function SelectType(props) {
  const { setSignInData, handleNext } = props;

  const handleChange = (text) => {
    setSignInData((prev) => ({ ...prev, state: text }));
    handleNext();
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          onClick={() => handleChange("registered")}
          sx={{ mt: 3, ml: 1, width: "300px" }}
       
          size="large"
        >
          Registered
        </Button>
        <Button
          variant="contained"
          onClick={() => handleChange("nonRegistered")}
          sx={{ mt: 3, ml: 1, width: "300px" }}
         
          size="large"
        >
          Non Registered
        </Button>
      </Box>

    </React.Fragment>
  );
}
